import { tns } from "../../../../../node_modules/tiny-slider/src/tiny-slider.js";

function sliderLogos() {
  const allSliders = document.querySelectorAll("[data-slider]");

  if (allSliders.length > 0) {
    for (let i = 0; i < allSliders.length; i++) {
      const slider = allSliders[i];
      let container = "[data-slider-" + (i + 1) + "]";
      slider.removeAttribute('data-slider')
      slider.setAttribute(`data-slider-${i + 1}`, "");

      const options = {
        container: container,
        mode: "carousel",
        items: 1,
        controls: true,
        controlsPosition: "bottom",
        nav: false,
        responsive: {
          576: {
            items: 2,
          },
          768: {
            items: 3,
          },
          992: {
            items: 4,
          },
          1200: {
            items: 4,
          },
        },
        speed: 400,
      };

      renderSliderContent(options)
    }
  }

  function renderSliderContent(options) {
    const sliderLogos = tns(options);
    return sliderLogos;
  }
}

sliderLogos();
